import React, { useEffect, useMemo } from 'react'
import { Select } from '@workwave-tidal/core/components'
import { useSelector } from 'react-redux'
import { selectAllRoles } from '@user/store/roles/slice'
import Box from '@mui/material/Box'
import { Role } from '@user/store/roles/typings'
import { useField, useFormikContext } from 'formik'
import { IUserFormModel } from './typings'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import FormHelperText from '@mui/material/FormHelperText'

type Props = {
  label: string
  disabled: boolean
  onChange: (value: Role | null) => void
  required?: boolean
}

export default function RoleSelect(props: Props) {
  const { onChange } = props
  const allRoles = useSelector(selectAllRoles)
  const { values } = useFormikContext<IUserFormModel>()

  const [{}, { error, touched }] = useField({ name: 'role' })

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  const tidalThemeActive = useTidalThemeActive()

  const sortedRoles = useMemo(
    () => allRoles?.sort((a, b) => (b.name > a.name ? -1 : 1)),
    [allRoles],
  )

  useEffect(() => {
    if (allRoles?.length == 1 && allRoles?.[0]?.systemCreated) {
      onChange(allRoles?.[0])
    }
  }, [allRoles])

  return (
    <Box>
      <Select<Role>
        {...props}
        items={sortedRoles}
        getLabel={(option) => option.name}
        required
        optionMode={'normal'}
        onChange={(value) => {
          onChange(value)
        }}
        value={values?.role || null}
        density={tidalThemeActive ? 'normal' : 'compact'}
        disableClearOnBlur
        error={showError}
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  )
}
